export const styles = {
  global: {
    body: {
      color: `white`,
      background: `milka.primary.lilac`
    }
  }
};
